import { render, staticRenderFns } from "./messageConfigDialog.vue?vue&type=template&id=185d7131&scoped=true"
import script from "./messageConfigDialog.vue?vue&type=script&lang=js"
export * from "./messageConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./messageConfigDialog.vue?vue&type=style&index=0&id=185d7131&prod&lang=scss"
import style1 from "./messageConfigDialog.vue?vue&type=style&index=1&id=185d7131&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185d7131",
  null
  
)

export default component.exports